/**
 * Shimmer — Loading placeholder that shows layout shape while data loads.
 */
export function Shimmer({ className = '', style = {} }) {
  return (
    <div
      className={`animate-pulse bg-gradient-to-r from-white/[0.03] via-white/[0.08] to-white/[0.03] bg-[length:200%_100%] rounded-xl ${className}`}
      style={{ animation: 'shimmer 1.5s ease-in-out infinite', ...style }}
    />
  );
}

export function DashboardSkeleton() {
  return (
    <div className="max-w-md mx-auto px-4 pt-3 pb-24 space-y-5">
      {/* Hero image */}
      <Shimmer className="h-56 rounded-3xl" />
      {/* Name */}
      <div>
        <Shimmer className="h-8 w-40 rounded-lg mb-2" />
        <Shimmer className="h-5 w-56 rounded-lg" />
      </div>
      {/* Today card */}
      <Shimmer className="h-32 rounded-3xl" />
      {/* Stats grid */}
      <Shimmer className="h-48 rounded-3xl" />
      {/* Program */}
      <Shimmer className="h-40 rounded-3xl" />
    </div>
  );
}

export function WorkoutSkeleton() {
  return (
    <div className="max-w-md mx-auto px-4 pt-3 pb-24 space-y-4">
      <Shimmer className="h-10 w-64 rounded-lg mb-4" />
      {[1,2,3,4,5,6,7].map(i => (
        <Shimmer key={i} className="h-28 rounded-2xl" />
      ))}
    </div>
  );
}
